// extracted by mini-css-extract-plugin
export default {"sections":"top-editor-sections_sections__CGZXD","section":"top-editor-sections_section__PSe0+"};